import { InjectionToken } from '@angular/core';
import { PopoverContent } from './popover-content';

export const POPOVER_CONTENT_DATA = new InjectionToken<PopoverContent>('POPOVER_CONTENT_DATA');
